import React, { useEffect, useState } from "react";
import './AzkarContainer.css';
import axios from "axios";

function AzkarContainer() {
    const [azkarcontainer, setAzkarcontainer] = useState({});
    const [searchText, setSearchText] = useState(""); // حالة لنص البحث
    const [filteredSections, setFilteredSections] = useState([]); // حالة للأقسام المصفاة

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `https://raw.githubusercontent.com/nawafalqari/azkar-api/56df51279ab6eb86dc2f6202c7de26c8948331c1/azkar.json`
                );
                setAzkarcontainer(response.data);
                setFilteredSections(Object.keys(response.data)); // عرض جميع الأقسام في البداية
            } catch (error) {
                console.error("Error fetching Azkar details:", error);
            }
        };
        fetchData();
    }, []);

    // دالة لإزالة التشكيل من النصوص
    const removeDiacritics = (text) => {
        return text.replace(/[\u0610-\u061A\u064B-\u065F\u06D6-\u06ED]/g, "");
    };

    useEffect(() => {
        // تصفية الأقسام بناءً على النص المدخل بدون التشكيل
        if (searchText.trim()) {
            const cleanedSearchText = removeDiacritics(searchText);
            setFilteredSections(
                Object.keys(azkarcontainer).filter((sectionKey) =>
                    removeDiacritics(sectionKey).includes(cleanedSearchText)
                )
            );
        } else {
            setFilteredSections(Object.keys(azkarcontainer)); // إذا لم يكن هناك نص بحث، عرض جميع الأقسام
        }
    }, [searchText, azkarcontainer]);

    const cleanText = (text) => {
        if (!text || text === "stop") return '';
        return text
            .replace(/\\n/g, '')
            .replace(/['"]/g, '')
            .replace(/,(\s*,)+/g, ',')
            .trim();
    };

    return (
        <div className="AzkarContainer">
            <h2>كل الأذكار</h2>
            <input
                style={{
                    width: "95%",
                    textAlign: "center",
                    margin: "auto",
                    fontWeight: "bold",
                    marginBottom:"10px",
                    fontFamily: "sans-serif"
                }}
                type="text"
                className="form-control"
                placeholder="ادخل نوع الاذكار الذي ترديه مثل الصباح او المساء والخ"
                aria-label="Search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
            />
            <div className="azkar-sections">
                {filteredSections.map((sectionKey) => (
                    <div key={sectionKey} className="azkar-section">
                        <h3>{sectionKey}</h3>
                        <div className="azkar-list">
                            {azkarcontainer[sectionKey]
                                .filter((azkar) => cleanText(azkar.content) !== '')
                                .map((azkar, index) => (
                                    <div key={index} className="azkar-item">
                                        {cleanText(azkar.content)}
                                    </div>
                                ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default AzkarContainer;
